import React from "react";

interface CircularProgressProps {
  size: number;
  strokeWidth: number;
  progress: number; // 0-100
  text: React.ReactNode;
  trackColor?: string;
  progressColor?: string;
  textColor?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  size,
  strokeWidth,
  progress,
  text,
  trackColor = "stroke-gray-500/50",
  progressColor = "stroke-white",
  textColor = "text-white",
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="transform -rotate-90">
        <circle
          className={trackColor}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          className={`${progressColor} transition-all duration-300`}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div
        className={`absolute flex flex-col items-center justify-center text-center ${textColor}`}
      >
        {text}
      </div>
    </div>
  );
};

export default CircularProgress;
